import React, { useState } from 'react';


import testiauthor1 from "../assets/images/testimonials/testi-author1.jpg"
import testiauthor3 from "../assets/images/testimonials/testi-author3.jpg"
import testiauthor4 from "../assets/images/testimonials/testi-author4.jpg"

const testimonialsData = [
    {
        id: 1,
        author: "Andrew D. Bricker",
        designation: "CEO & Founder",
        text: "Sed ut perspiciatis unde omnis iste natus voluptatem accus antiume dolorem queauy antium totam aperiam eaque quaey abillosa inventore veritatis vitaec",
        image: testiauthor1,
    },
    {
        id: 2,
        author: "Michael M. Callaway",
        designation: "CEO & Founder",
        text: "On the other hand denounce righteous indignation and dislike men who are so beguiled and demorzed charms of pleasure of the moment blinde",
        image: testiauthor3,
    },
    {
        id: 3,
        author: "William G. Manno",
        designation: "CEO & Founder",
        text: "At vero eos et accusamuse iusto odio dignissimos ducimus qui blanditiis praesentium voluptatu delntc atque corrupti quos dolores quas molestias",
        image: testiauthor4,
    },
];

const TestimonialSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextTestimonial = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
    };

    const prevTestimonial = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonialsData.length) % testimonialsData.length);
    };

    return (
        <div className="testimonials-container">
            <div className="testimonial-item">
                <div className="image">
                    <img src={testimonialsData[currentIndex].image} alt="Author" />
                </div>
                <div className="content">
                    <div className="testi-header">
                        <h4>Excellent Works</h4>
                    </div>
                    <div className="testi-text">
                        {testimonialsData[currentIndex].text}
                    </div>
                    <div className="testi-footer">
                        <div className="icon">
                            <i className="flaticon-quotation" />
                        </div>
                        <div className="title">
                            <h4>{testimonialsData[currentIndex].author}</h4>
                            <span className="designation">{testimonialsData[currentIndex].designation}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="slider-buttons">
                <button className="nav-button" onClick={prevTestimonial} disabled={currentIndex === 0}>
                    <i className="fas fa-chevron-left"></i> {/* Left arrow icon */}
                </button>
                <button className="nav-button" onClick={nextTestimonial} disabled={currentIndex === testimonialsData.length - 1}>
                    <i className="fas fa-chevron-right"></i> {/* Right arrow icon */}
                </button>
            </div>

        </div>
    );
};

export default TestimonialSlider;
